import { useInterpret } from '@xstate/react';
import type { ActorRefFrom } from 'xstate';

import { AuthMachine } from './AuthMachine';
import { AuthStorage } from './AuthStorage';

export type AuthMachineRefType = ActorRefFrom<typeof AuthMachine>;

export const useInitAuthMachine = () => {
  const authMachineRef = useInterpret(AuthMachine, {
    actions: {
      async saveCsrfTokenToStorage(_context, event) {
        await AuthStorage.setToken(event.csrfToken);
      },
    },
  });

  return authMachineRef;
};
